export const SOFTLINE_API_LAGERPLATZ = "/v1/lagerplatz/scan-suche/{{code}}";
export const SOFTLINE_API_LAGERSYMBOL = '/v1/lagersymbol/entities';
export const SOFTLINE_API_LAGERPLATZ_VERFÜGBAR = 'v1/lagerplatzverfuegbar/{{idbewekomm}}';
export const SOFTLINE_API_ANWENDER_LAGER = 'v1/anwenderlager/entities';
